
    export default {
    
        "./analytics": async () => {
          const importModule = await import("../lib/analytics/src/index.ts")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./Chords": async () => {
          const importModule = await import("./src/chords/index.ts")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./Shell": async () => {
          const importModule = await import("./src/Shell.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./DdexAccess": async () => {
          const importModule = await import("./src/modules/ddex-console/module-federation/DdexAccessGate.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      
  }
  